<template>
    <div>
        <headline>Berechtigungen</headline>

        <tailwind-table :header="['User', 'Rechte', 'Editieren']">
            <tr v-for="(user, index) in copy" :key="user.id" :class="{'bg-gray-50': index%2}">
                <td class="px-6 py-3">
                    {{ user.email }}
                </td>
                <td class="px-6 py-3">
                    <span v-show="user.is_admin">Vollzugriff</span>
                    <span v-show="user.is_sub_admin">Teilzugriff</span>
                    <span v-show="!user.is_admin && !user.is_sub_admin">-</span>
                </td>
                <td class="px-6 py-3 text-right">
                    <permission-edit-dialog v-show="admin.is_admin" v-model="copy[index]"></permission-edit-dialog>
                </td>
            </tr>
        </tailwind-table>
    </div>
</template>

<script>
import Headline from "../components/UI/Headline";
import PermissionEditDialog from "../components/UI/PermissionEditDialog";
import TailwindTable from "../components/UI/TailwindTable";

export default {
    name: "Permissions",
    inject: ['admin'],

    components: {TailwindTable, PermissionEditDialog, Headline},

    props: ['users'],

    data: (vm) => ({
        copy: vm.users,
    }),

}
</script>

<style scoped>

</style>
